const { mediaQuery } = require('../helpers');

document.addEventListener('DOMContentLoaded', () => {
	const stickyBar = document.querySelector('.vacancy-sticky-bar');
	const headerSmall = document.querySelector('.header-small');
	const siteHeader = document.querySelector('#site-header');

	if (!stickyBar || !headerSmall || !siteHeader) {
		return;
	}

	const setStickyBarHeight = (isVisible) => {
		const height = isVisible ? stickyBar.offsetHeight + 32 : 0;
		document.documentElement.style.setProperty('--strl-vacancy-sticky-bar-height', `${height}px`);
	};

	const syncWithHeader = () => {
		const belowHeader = mediaQuery('xl') || siteHeader.classList.contains('show');
		stickyBar.classList.toggle('below-header', belowHeader);
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				const isVisible = !entry.isIntersecting;
				stickyBar.classList.toggle('is-visible', isVisible);
				stickyBar.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
				setStickyBarHeight(isVisible);
			});
		},
		{
			threshold: 0,
		}
	);

	observer.observe(headerSmall);
	syncWithHeader();

	const headerObserver = new MutationObserver(syncWithHeader);
	headerObserver.observe(siteHeader, {
		attributes: true,
		attributeFilter: ['class'],
	});

	window.addEventListener('resize', () => {
		syncWithHeader();
		setStickyBarHeight(stickyBar.classList.contains('is-visible'));
	});
});
